import { useEffect, useState } from "react";
import { RequestServer } from "../services";
import { formatData } from "../../pages/Projects/helper";
import { FormattedData } from "../../pages/Projects/types";

export const useOptionsFetch = (url: string) => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState<FormattedData>([]);
  const [serverError, setServerError] = useState<any>(null);
  const [rawData, setRawData] = useState<any>([]);
  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        let clientsData = await RequestServer(url, "GET");
        const data = formatData(clientsData?.data);
        setRawData(clientsData?.data);
        setApiData(data);
        setIsLoading(false);
      } catch (error) {
        setServerError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { isLoading, apiData, serverError , rawData};
};
